import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiServerDac } from '@/services/api';
import { DetalhesEmentaComponent } from '@/components/PagesComponents/DetalhesEmenta';
import { IDetalhesDisciplina } from '@/@types/Academico/Disciplina';

const DetalhesEmenta = () => {
    const [data, setData] = useState<IDetalhesDisciplina>({} as IDetalhesDisciplina);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { cod_disci, ano } = useParams();

    useEffect(() => {
        const getDetalhesEmentaData = async () => {
            // server-dac V2 substitui /disciplinas/allyears preservando { disciplinas }.
            const url = `/v2/disciplinas_catalogo/anos?ano=${ano}&cod_disci=${cod_disci}`;

            setIsLoading(true);

            try {
                const response = await apiServerDac.get(url);
                setData(response.data.disciplinas[0]);
                setIsLoading(false);
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        };

        getDetalhesEmentaData();
    }, [ano, cod_disci]);

    return (
        <DetalhesEmentaComponent isLoading={isLoading} data={data} />
    );
};

export { DetalhesEmenta };
